var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.25L3.75 2.25C2.925 2.25 2.25 2.925 2.25 3.75L2.25 14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V3.75C15.75 2.925 15.075 2.25 14.25 2.25ZM6 12.75C5.5875 12.75 5.25 12.4125 5.25 12V8.25C5.25 7.8375 5.5875 7.5 6 7.5C6.4125 7.5 6.75 7.8375 6.75 8.25V12C6.75 12.4125 6.4125 12.75 6 12.75ZM9 12.75C8.5875 12.75 8.25 12.4125 8.25 12V6C8.25 5.5875 8.5875 5.25 9 5.25C9.4125 5.25 9.75 5.5875 9.75 6V12C9.75 12.4125 9.4125 12.75 9 12.75ZM12 12.75C11.5875 12.75 11.25 12.4125 11.25 12V10.5C11.25 10.0875 11.5875 9.75 12 9.75C12.4125 9.75 12.75 10.0875 12.75 10.5V12C12.75 12.4125 12.4125 12.75 12 12.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.354c1151ecaa8a812e4c72708b8ccbeb.svg";
export { ForwardRef as ReactComponent };